var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttons-wrapper"},[_c('div',[_vm._t("leftTop")],2),_c('div',[_vm._t("rightTop")],2),_c('div',[_vm._t("leftBottom")],2),_c('div',[_vm._t("rightBottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }